webpackJsonp(["diff_notes"],{

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./diff_notes/components/comment_resolve_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable comma-dangle, object-shorthand, func-names, no-else-return, quotes, no-lonely-if, max-len */
/* global CommentsStore */



var CommentAndResolveBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: String
  },
  data: function data() {
    return {
      textareaIsEmpty: true,
      discussion: {}
    };
  },

  computed: {
    showButton: function showButton() {
      if (this.discussion) {
        return this.discussion.isResolvable();
      } else {
        return false;
      }
    },
    isDiscussionResolved: function isDiscussionResolved() {
      return this.discussion.isResolved();
    },
    buttonText: function buttonText() {
      if (this.isDiscussionResolved) {
        if (this.textareaIsEmpty) {
          return "未解决讨论";
        } else {
          return "评论 & 未解决讨论";
        }
      } else {
        if (this.textareaIsEmpty) {
          return "解决讨论";
        } else {
          return "评论 & 解决讨论";
        }
      }
    }
  },
  created: function created() {
    if (this.discussionId) {
      this.discussion = CommentsStore.state[this.discussionId];
    }
  },

  mounted: function mounted() {
    var _this = this;

    if (!this.discussionId) return;

    var $textarea = $(".js-discussion-note-form[data-discussion-id=" + this.discussionId + "] .note-textarea");
    this.textareaIsEmpty = $textarea.val() === '';

    $textarea.on('input.comment-and-resolve-btn', function () {
      _this.textareaIsEmpty = $textarea.val() === '';
    });
  },
  destroyed: function destroyed() {
    if (!this.discussionId) return;

    $(".js-discussion-note-form[data-discussion-id=" + this.discussionId + "] .note-textarea").off('input.comment-and-resolve-btn');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('comment-and-resolve-btn', CommentAndResolveBtn);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/diff_note_avatars.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg__ = __webpack_require__("./diff_notes/icons/collapse_icon.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notes__ = __webpack_require__("./notes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_user_avatar_user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* global CommentsStore */






var DiffNoteAvatars = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: ['discussionId'],
  data: function data() {
    return {
      isVisible: false,
      lineType: '',
      storeState: CommentsStore.state,
      shownAvatars: 3,
      collapseIcon: __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg___default.a
    };
  },

  components: {
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_user_avatar_user_avatar_image_vue__["a" /* default */]
  },
  template: '\n    <div class="diff-comment-avatar-holders"\n      :class="discussionClassName"\n      v-show="notesCount !== 0">\n      <div v-if="!isVisible">\n        <!-- FIXME: Pass an alt attribute here for accessibility -->\n        <user-avatar-image\n          v-for="note in notesSubset"\n          :key="note.id"\n          class="diff-comment-avatar js-diff-comment-avatar"\n          @click.native="clickedAvatar($event)"\n          :img-src="note.authorAvatar"\n          :tooltip-text="getTooltipText(note)"\n          :data-line-type="lineType"\n          :size="19"\n          data-html="true"\n        />\n        <span v-if="notesCount > shownAvatars"\n          class="diff-comments-more-count has-tooltip js-diff-comment-avatar"\n          data-container="body"\n          data-placement="top"\n          ref="extraComments"\n          role="button"\n          :data-line-type="lineType"\n          :title="extraNotesTitle"\n          @click="clickedAvatar($event)">{{ moreText }}</span>\n      </div>\n      <button class="diff-notes-collapse js-diff-comment-avatar"\n        type="button"\n        aria-label="Show comments"\n        :data-line-type="lineType"\n        @click="clickedAvatar($event)"\n        v-if="isVisible"\n        v-html="collapseIcon">\n      </button>\n    </div>\n  ',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.addNoCommentClass();
      _this.setDiscussionVisible();

      _this.lineType = $(_this.$el).closest('.diff-line-num').hasClass('old_line') ? 'old' : 'new';
    });

    $(document).on('toggle.comments', function () {
      _this.$nextTick(function () {
        _this.setDiscussionVisible();
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.addNoCommentClass();
    $(document).off('toggle.comments');
  },

  watch: {
    storeState: {
      handler: function handler() {
        var _this2 = this;

        this.$nextTick(function () {
          $('.has-tooltip', _this2.$el).tooltip('fixTitle');

          // We need to add/remove a class to an element that is outside the Vue instance
          _this2.addNoCommentClass();
        });
      },

      deep: true
    }
  },
  computed: {
    discussionClassName: function discussionClassName() {
      return 'js-diff-avatars-' + this.discussionId;
    },
    notesSubset: function notesSubset() {
      var _this3 = this;

      var notes = [];

      if (this.discussion) {
        notes = Object.keys(this.discussion.notes).slice(0, this.shownAvatars).map(function (noteId) {
          return _this3.discussion.notes[noteId];
        });
      }

      return notes;
    },
    extraNotesTitle: function extraNotesTitle() {
      if (this.discussion) {
        var extra = this.discussion.notesCount() - this.shownAvatars;

        return extra + ' more comment' + (extra > 1 ? 's' : '');
      }

      return '';
    },
    discussion: function discussion() {
      return this.storeState[this.discussionId];
    },
    notesCount: function notesCount() {
      if (this.discussion) {
        return this.discussion.notesCount();
      }

      return 0;
    },
    moreText: function moreText() {
      var plusSign = this.notesCount < 100 ? '+' : '';

      return '' + plusSign + (this.notesCount - this.shownAvatars);
    }
  },
  methods: {
    clickedAvatar: function clickedAvatar(e) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__notes__["a" /* default */].instance.onAddDiffNote(e);

      // Toggle the active state of the toggle all button
      this.toggleDiscussionsToggleState();

      this.$nextTick(function () {
        _this4.setDiscussionVisible();

        $('.has-tooltip', _this4.$el).tooltip('fixTitle');
        $('.has-tooltip', _this4.$el).tooltip('hide');
      });
    },
    addNoCommentClass: function addNoCommentClass() {
      var notesCount = this.notesCount;

      $(this.$el).closest('.js-avatar-container').toggleClass('no-comment-btn', notesCount > 0).nextUntil('.js-avatar-container').toggleClass('no-comment-btn', notesCount > 0);
    },
    toggleDiscussionsToggleState: function toggleDiscussionsToggleState() {
      var $notesHolders = $(this.$el).closest('.code').find('.notes_holder');
      var $visibleNotesHolders = $notesHolders.filter(':visible');
      var $toggleDiffCommentsBtn = $(this.$el).closest('.diff-file').find('.js-toggle-diff-comments');

      $toggleDiffCommentsBtn.toggleClass('active', $notesHolders.length === $visibleNotesHolders.length);
    },
    setDiscussionVisible: function setDiscussionVisible() {
      this.isVisible = $('.diffs .notes[data-discussion-id="' + this.discussion.id + '"]').is(':visible');
    },
    getTooltipText: function getTooltipText(note) {
      return note.authorName + ': ' + note.noteTruncated;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('diff-note-avatars', DiffNoteAvatars);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/jump_to_discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mixins_discussion__);
/* eslint-disable comma-dangle, object-shorthand, func-names, no-else-return, guard-for-in, no-restricted-syntax, one-var, space-before-function-paren, no-lonely-if, no-continue, brace-style, max-len, quotes */
/* global DiscussionMixins */
/* global CommentsStore */





var JumpToDiscussion = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  mixins: [DiscussionMixins],
  props: {
    discussionId: String
  },
  data: function data() {
    return {
      discussions: CommentsStore.state,
      discussion: {}
    };
  },
  computed: {
    buttonText: function buttonText() {
      if (this.discussionId) {
        return 'Jump to next unresolved discussion';
      } else {
        return 'Jump to first unresolved discussion';
      }
    },
    allResolved: function allResolved() {
      return this.unresolvedDiscussionCount === 0;
    },
    showButton: function showButton() {
      if (this.discussionId) {
        if (this.unresolvedDiscussionCount > 1) {
          return true;
        } else {
          return this.discussionId !== this.lastResolvedId;
        }
      } else {
        return this.unresolvedDiscussionCount >= 1;
      }
    },
    lastResolvedId: function lastResolvedId() {
      var lastId = void 0;
      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (!discussion.isResolved()) {
          lastId = discussion.id;
        }
      }
      return lastId;
    }
  },
  methods: {
    jumpToNextUnresolvedDiscussion: function jumpToNextUnresolvedDiscussion() {
      var discussionsSelector = void 0;
      var discussionIdsInScope = void 0;
      var firstUnresolvedDiscussionId = void 0;
      var nextUnresolvedDiscussionId = void 0;
      var activeTab = window.mrTabs.currentAction;
      var hasDiscussionsToJumpTo = true;
      var jumpToFirstDiscussion = !this.discussionId;

      var discussionIdsForElements = function discussionIdsForElements(elements) {
        return elements.map(function () {
          return $(this).attr('data-discussion-id');
        }).toArray();
      };

      var discussions = this.discussions;

      if (activeTab === 'diffs') {
        discussionsSelector = '.diffs .notes[data-discussion-id]';
        discussionIdsInScope = discussionIdsForElements($(discussionsSelector));

        var unresolvedDiscussionCount = 0;

        for (var i = 0; i < discussionIdsInScope.length; i += 1) {
          var discussionId = discussionIdsInScope[i];
          var discussion = discussions[discussionId];
          if (discussion && !discussion.isResolved()) {
            unresolvedDiscussionCount += 1;
          }
        }

        if (this.discussionId && !this.discussion.isResolved()) {
          // If this is the last unresolved discussion on the diffs tab,
          // there are no discussions to jump to.
          if (unresolvedDiscussionCount === 1) {
            hasDiscussionsToJumpTo = false;
          }
        } else {
          // If there are no unresolved discussions on the diffs tab at all,
          // there are no discussions to jump to.
          if (unresolvedDiscussionCount === 0) {
            hasDiscussionsToJumpTo = false;
          }
        }
      } else if (activeTab !== 'show') {
        // If we are on the commits or builds tabs,
        // there are no discussions to jump to.
        hasDiscussionsToJumpTo = false;
      }

      if (!hasDiscussionsToJumpTo) {
        // If there are no discussions to jump to on the current page,
        // switch to the notes tab and jump to the first disucssion there.
        window.mrTabs.activateTab('show');
        activeTab = 'show';
        jumpToFirstDiscussion = true;
      }

      if (activeTab === 'show') {
        discussionsSelector = '.discussion[data-discussion-id]';
        discussionIdsInScope = discussionIdsForElements($(discussionsSelector));
      }

      var currentDiscussionFound = false;
      for (var _i = 0; _i < discussionIdsInScope.length; _i += 1) {
        var _discussionId = discussionIdsInScope[_i];
        var _discussion = discussions[_discussionId];

        if (!_discussion) {
          // Discussions for comments on commits in this MR don't have a resolved status.
          continue;
        }

        if (!firstUnresolvedDiscussionId && !_discussion.isResolved()) {
          firstUnresolvedDiscussionId = _discussionId;

          if (jumpToFirstDiscussion) {
            break;
          }
        }

        if (!jumpToFirstDiscussion) {
          if (currentDiscussionFound) {
            if (!_discussion.isResolved()) {
              nextUnresolvedDiscussionId = _discussionId;
              break;
            } else {
              continue;
            }
          }

          if (_discussionId === this.discussionId) {
            currentDiscussionFound = true;
          }
        }
      }

      nextUnresolvedDiscussionId = nextUnresolvedDiscussionId || firstUnresolvedDiscussionId;

      if (!nextUnresolvedDiscussionId) {
        return;
      }

      var $target = $(discussionsSelector + '[data-discussion-id="' + nextUnresolvedDiscussionId + '"]');

      if (activeTab === 'show') {
        $target = $target.closest('.note-discussion');

        // If the next discussion is closed, toggle it open.
        if ($target.find('.js-toggle-content').is(':hidden')) {
          $target.find('.js-toggle-button i').trigger('click');
        }
      } else if (activeTab === 'diffs') {
        // Resolved discussions are hidden in the diffs tab by default.
        // If they are marked unresolved on the notes tab, they will still be hidden on the diffs tab.
        // When jumping between unresolved discussions on the diffs tab, we show them.
        $target.closest(".content").show();

        var $notesHolder = $target.closest("tr.notes_holder");

        // Image diff discussions does not use notes_holder
        // so we should keep original $target value in those cases
        if ($notesHolder.length > 0) {
          $target = $notesHolder;
        }

        $target.show();

        // If we are on the diffs tab, we don't scroll to the discussion itself, but to
        // 4 diff lines above it: the line the discussion was in response to + 3 context
        var prevEl = void 0;
        for (var _i2 = 0; _i2 < 4; _i2 += 1) {
          prevEl = $target.prev();

          // If the discussion doesn't have 4 lines above it, we'll have to do with fewer.
          if (!prevEl.hasClass("line_holder")) {
            break;
          }

          $target = prevEl;
        }
      }

      $.scrollTo($target, {
        offset: 0
      });
    }
  },
  created: function created() {
    this.discussion = this.discussions[this.discussionId];
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('jump-to-discussion', JumpToDiscussion);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/new_issue_for_discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* global CommentsStore */



var NewIssueForDiscussion = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      discussions: CommentsStore.state
    };
  },

  computed: {
    discussion: function discussion() {
      return this.discussions[this.discussionId];
    },
    showButton: function showButton() {
      if (this.discussion) return !this.discussion.isResolved();
      return false;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('new-issue-for-discussion-btn', NewIssueForDiscussion);

/***/ }),

/***/ "./diff_notes/components/resolve_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* eslint-disable comma-dangle, object-shorthand, func-names, quote-props, no-else-return, camelcase, max-len */
/* global CommentsStore */
/* global ResolveService */




var ResolveBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    noteId: Number,
    discussionId: String,
    resolved: Boolean,
    canResolve: Boolean,
    resolvedBy: String,
    authorName: String,
    authorAvatar: String,
    noteTruncated: String
  },
  data: function data() {
    return {
      discussions: CommentsStore.state,
      loading: false
    };
  },
  watch: {
    'discussions': {
      handler: 'updateTooltip',
      deep: true
    }
  },
  computed: {
    discussion: function discussion() {
      return this.discussions[this.discussionId];
    },
    note: function note() {
      return this.discussion ? this.discussion.getNote(this.noteId) : {};
    },
    buttonText: function buttonText() {
      if (this.isResolved) {
        return 'Resolved by ' + this.resolvedByName;
      } else if (this.canResolve) {
        return '标记为已解决';
      } else {
        return '无法解决';
      }
    },
    isResolved: function isResolved() {
      if (this.note) {
        return this.note.resolved;
      } else {
        return false;
      }
    },
    resolvedByName: function resolvedByName() {
      return this.note.resolved_by;
    }
  },
  methods: {
    updateTooltip: function updateTooltip() {
      var _this = this;

      this.$nextTick(function () {
        $(_this.$refs.button).tooltip('hide').tooltip('fixTitle');
      });
    },
    resolve: function resolve() {
      var _this2 = this;

      if (!this.canResolve) return;

      var promise = void 0;
      this.loading = true;

      if (this.isResolved) {
        promise = ResolveService.unresolve(this.noteId);
      } else {
        promise = ResolveService.resolve(this.noteId);
      }

      promise.then(function (resp) {
        return resp.json();
      }).then(function (data) {
        _this2.loading = false;

        var resolved_by = data ? data.resolved_by : null;

        CommentsStore.update(_this2.discussionId, _this2.noteId, !_this2.isResolved, resolved_by);
        _this2.discussion.updateHeadline(data);
        gl.mrWidget.checkStatus();

        _this2.updateTooltip();
      }).catch(function () {
        return new __WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */]('An error occurred when trying to resolve a comment. Please try again.');
      });
    }
  },
  mounted: function mounted() {
    $(this.$refs.button).tooltip({
      container: 'body'
    });
  },
  beforeDestroy: function beforeDestroy() {
    CommentsStore.delete(this.discussionId, this.noteId);
  },
  created: function created() {
    CommentsStore.create({
      discussionId: this.discussionId,
      noteId: this.noteId,
      canResolve: this.canResolve,
      resolved: this.resolved,
      resolvedBy: this.resolvedBy,
      authorName: this.authorName,
      authorAvatar: this.authorAvatar,
      noteTruncated: this.noteTruncated
    });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('resolve-btn', ResolveBtn);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/resolve_count.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mixins_discussion__);
/* eslint-disable comma-dangle, object-shorthand, func-names, no-param-reassign */
/* global DiscussionMixins */
/* global CommentsStore */





window.ResolveCount = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  mixins: [DiscussionMixins],
  props: {
    loggedOut: Boolean
  },
  data: function data() {
    return {
      discussions: CommentsStore.state
    };
  },
  computed: {
    allResolved: function allResolved() {
      return this.resolvedDiscussionCount === this.discussionCount;
    },
    resolvedCountText: function resolvedCountText() {
      return this.discussionCount === 1 ? '讨论' : '讨论';
    }
  }
});

/***/ }),

/***/ "./diff_notes/components/resolve_discussion_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable object-shorthand, func-names, space-before-function-paren, comma-dangle, no-else-return, quotes, max-len */
/* global CommentsStore */
/* global ResolveService */



var ResolveDiscussionBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: String,
    mergeRequestId: Number,
    canResolve: Boolean
  },
  data: function data() {
    return {
      discussion: {}
    };
  },
  computed: {
    showButton: function showButton() {
      if (this.discussion) {
        return this.discussion.isResolvable();
      } else {
        return false;
      }
    },
    isDiscussionResolved: function isDiscussionResolved() {
      if (this.discussion) {
        return this.discussion.isResolved();
      } else {
        return false;
      }
    },
    buttonText: function buttonText() {
      if (this.isDiscussionResolved) {
        return "Unresolve discussion";
      } else {
        return "Resolve discussion";
      }
    },
    loading: function loading() {
      if (this.discussion) {
        return this.discussion.loading;
      } else {
        return false;
      }
    }
  },
  methods: {
    resolve: function resolve() {
      ResolveService.toggleResolveForDiscussion(this.mergeRequestId, this.discussionId);
    }
  },
  created: function created() {
    CommentsStore.createDiscussion(this.discussionId, this.canResolve);

    this.discussion = CommentsStore.state[this.discussionId];
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('resolve-discussion-btn', ResolveDiscussionBtn);

/***/ }),

/***/ "./diff_notes/diff_notes_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_discussion__ = __webpack_require__("./diff_notes/models/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_note__ = __webpack_require__("./diff_notes/models/note.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__models_note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_comments__ = __webpack_require__("./diff_notes/stores/comments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_resolve__ = __webpack_require__("./diff_notes/services/resolve.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mixins_discussion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_comment_resolve_btn__ = __webpack_require__("./diff_notes/components/comment_resolve_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_jump_to_discussion__ = __webpack_require__("./diff_notes/components/jump_to_discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_resolve_btn__ = __webpack_require__("./diff_notes/components/resolve_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_resolve_count__ = __webpack_require__("./diff_notes/components/resolve_count.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_resolve_discussion_btn__ = __webpack_require__("./diff_notes/components/resolve_discussion_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_diff_note_avatars__ = __webpack_require__("./diff_notes/components/diff_note_avatars.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_new_issue_for_discussion__ = __webpack_require__("./diff_notes/components/new_issue_for_discussion.js");
/* eslint-disable func-names, comma-dangle, new-cap, no-new, max-len */
/* global ResolveCount */















$(function () {
  var projectPathHolder = document.querySelector('.merge-request') || document.querySelector('.commit-box');
  var projectPath = projectPathHolder.dataset.projectPath;
  var COMPONENT_SELECTOR = 'resolve-btn, resolve-discussion-btn, jump-to-discussion, comment-and-resolve-btn, new-issue-for-discussion-btn';

  window.gl = window.gl || {};
  window.gl.diffNoteApps = {};

  window.ResolveService = new gl.DiffNotesResolveServiceClass(projectPath);

  gl.diffNotesCompileComponents = function () {
    $('diff-note-avatars').each(function () {
      var tmp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
        template: $(this).get(0).outerHTML
      });
      var tmpApp = new tmp().$mount();

      $(this).replaceWith(tmpApp.$el);
      $(tmpApp.$el).one('remove.vue', function () {
        tmpApp.$destroy();
        tmpApp.$el.remove();
      });
    });

    var $components = $(COMPONENT_SELECTOR).filter(function () {
      return $(this).closest('resolve-count').length !== 1;
    });

    if ($components) {
      $components.each(function () {
        var $this = $(this);
        var noteId = $this.attr(':note-id');
        var discussionId = $this.attr(':discussion-id');

        if ($this.is('comment-and-resolve-btn') && !discussionId) return;

        var tmp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
          template: $this.get(0).outerHTML
        });
        var tmpApp = new tmp().$mount();

        if (noteId) {
          gl.diffNoteApps['note_' + noteId] = tmpApp;
        }

        $this.replaceWith(tmpApp.$el);
      });
    }
  };

  gl.diffNotesCompileComponents();

  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#resolve-count-app',
    components: {
      'resolve-count': ResolveCount
    }
  });

  $(window).trigger('resize.nav');
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/icons/collapse_icon.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"11\" height=\"11\" viewBox=\"0 0 9 13\"><path d=\"M2.57568253,6.49866948 C2.50548852,6.57199715 2.44637866,6.59708255 2.39835118,6.57392645 C2.3503237,6.55077034 2.32631032,6.48902165 2.32631032,6.38867852 L2.32631032,-2.13272614 C2.32631032,-2.23306927 2.3503237,-2.29481796 2.39835118,-2.31797406 C2.44637866,-2.34113017 2.50548852,-2.31604477 2.57568253,-2.24271709 L6.51022184,1.86747129 C6.53977721,1.8983461 6.56379059,1.93500939 6.5822627,1.97746225 L6.5822627,2.27849013 C6.56379059,2.31708364 6.53977721,2.35374693 6.51022184,2.38848109 L2.57568253,6.49866948 Z\" transform=\"translate(4.454287, 2.127976) rotate(90.000000) translate(-4.454287, -2.127976) \"></path><path d=\"M3.74312342,2.09553332 C3.74312342,1.99519019 3.77821989,1.9083561 3.8484139,1.83502843 C3.91860791,1.76170075 4.00173115,1.72503747 4.09778611,1.72503747 L4.80711151,1.72503747 C4.90316647,1.72503747 4.98628971,1.76170075 5.05648372,1.83502843 C5.12667773,1.9083561 5.16177421,1.99519019 5.16177421,2.09553332 L5.16177421,10.2464421 C5.16177421,10.3467853 5.12667773,10.4336194 5.05648372,10.506947 C4.98628971,10.5802747 4.90316647,10.616938 4.80711151,10.616938 L4.09778611,10.616938 C4.00173115,10.616938 3.91860791,10.5802747 3.8484139,10.506947 C3.77821989,10.4336194 3.74312342,10.3467853 3.74312342,10.2464421 L3.74312342,2.09553332 Z\" transform=\"translate(4.452449, 6.170988) rotate(-90.000000) translate(-4.452449, -6.170988) \"></path><path d=\"M2.57568253,14.6236695 C2.50548852,14.6969971 2.44637866,14.7220826 2.39835118,14.6989264 C2.3503237,14.6757703 2.32631032,14.6140216 2.32631032,14.5136785 L2.32631032,5.99227386 C2.32631032,5.89193073 2.3503237,5.83018204 2.39835118,5.80702594 C2.44637866,5.78386983 2.50548852,5.80895523 2.57568253,5.88228291 L6.51022184,9.99247129 C6.53977721,10.0233461 6.56379059,10.0600094 6.5822627,10.1024622 L6.5822627,10.4034901 C6.56379059,10.4420836 6.53977721,10.4787469 6.51022184,10.5134811 L2.57568253,14.6236695 Z\" transform=\"translate(4.454287, 10.252976) scale(1, -1) rotate(90.000000) translate(-4.454287, -10.252976) \"></path></svg>\n"

/***/ }),

/***/ "./diff_notes/mixins/discussion.js":
/***/ (function(module, exports) {

/* eslint-disable object-shorthand, func-names, guard-for-in, no-restricted-syntax, comma-dangle, no-param-reassign, max-len */

window.DiscussionMixins = {
  computed: {
    discussionCount: function discussionCount() {
      return Object.keys(this.discussions).length;
    },
    resolvedDiscussionCount: function resolvedDiscussionCount() {
      var resolvedCount = 0;

      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (discussion.isResolved()) {
          resolvedCount += 1;
        }
      }

      return resolvedCount;
    },
    unresolvedDiscussionCount: function unresolvedDiscussionCount() {
      var unresolvedCount = 0;

      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (!discussion.isResolved()) {
          unresolvedCount += 1;
        }
      }

      return unresolvedCount;
    }
  }
};

/***/ }),

/***/ "./diff_notes/models/discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable space-before-function-paren, camelcase, guard-for-in, no-restricted-syntax, no-unused-vars, max-len */
/* global NoteModel */




var DiscussionModel = function () {
  function DiscussionModel(discussionId) {
    _classCallCheck(this, DiscussionModel);

    this.id = discussionId;
    this.notes = {};
    this.loading = false;
    this.canResolve = false;
  }

  _createClass(DiscussionModel, [{
    key: 'createNote',
    value: function createNote(noteObj) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.notes, noteObj.noteId, new NoteModel(this.id, noteObj));
    }
  }, {
    key: 'deleteNote',
    value: function deleteNote(noteId) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].delete(this.notes, noteId);
    }
  }, {
    key: 'getNote',
    value: function getNote(noteId) {
      return this.notes[noteId];
    }
  }, {
    key: 'notesCount',
    value: function notesCount() {
      return Object.keys(this.notes).length;
    }
  }, {
    key: 'isResolved',
    value: function isResolved() {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (!note.resolved) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: 'resolveAllNotes',
    value: function resolveAllNotes(resolved_by) {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (!note.resolved) {
          note.resolved = true;
          note.resolved_by = resolved_by;
        }
      }
    }
  }, {
    key: 'unResolveAllNotes',
    value: function unResolveAllNotes() {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (note.resolved) {
          note.resolved = false;
          note.resolved_by = null;
        }
      }
    }
  }, {
    key: 'updateHeadline',
    value: function updateHeadline(data) {
      var discussionSelector = '.discussion[data-discussion-id="' + this.id + '"]';
      var $discussionHeadline = $(discussionSelector + ' .js-discussion-headline');

      if (data.discussion_headline_html) {
        if ($discussionHeadline.length) {
          $discussionHeadline.replaceWith(data.discussion_headline_html);
        } else {
          $(discussionSelector + ' .discussion-header').append(data.discussion_headline_html);
        }

        Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_datetime_utility__["e" /* localTimeAgo */])($('.js-timeago', '' + discussionSelector));
      } else {
        $discussionHeadline.remove();
      }
    }
  }, {
    key: 'isResolvable',
    value: function isResolvable() {
      if (!this.canResolve) {
        return false;
      }

      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (note.canResolve) {
          return true;
        }
      }

      return false;
    }
  }]);

  return DiscussionModel;
}();

window.DiscussionModel = DiscussionModel;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/models/note.js":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable camelcase, no-unused-vars */

var NoteModel = function NoteModel(discussionId, noteObj) {
  _classCallCheck(this, NoteModel);

  this.discussionId = discussionId;
  this.id = noteObj.noteId;
  this.canResolve = noteObj.canResolve;
  this.resolved = noteObj.resolved;
  this.resolved_by = noteObj.resolvedBy;
  this.authorName = noteObj.authorName;
  this.authorAvatar = noteObj.authorAvatar;
  this.noteTruncated = noteObj.noteTruncated;
};

window.NoteModel = NoteModel;

/***/ }),

/***/ "./diff_notes/services/resolve.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_vue_resource_interceptor__ = __webpack_require__("./vue_shared/vue_resource_interceptor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global CommentsStore */





window.gl = window.gl || {};

var ResolveServiceClass = function () {
  function ResolveServiceClass(root) {
    _classCallCheck(this, ResolveServiceClass);

    this.noteResource = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(root + '/notes{/noteId}/resolve');
    this.discussionResource = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(root + '/merge_requests{/mergeRequestId}/discussions{/discussionId}/resolve');
  }

  _createClass(ResolveServiceClass, [{
    key: 'resolve',
    value: function resolve(noteId) {
      return this.noteResource.save({ noteId: noteId }, {});
    }
  }, {
    key: 'unresolve',
    value: function unresolve(noteId) {
      return this.noteResource.delete({ noteId: noteId }, {});
    }
  }, {
    key: 'toggleResolveForDiscussion',
    value: function toggleResolveForDiscussion(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];
      var isResolved = discussion.isResolved();
      var promise = void 0;

      if (isResolved) {
        promise = this.unResolveAll(mergeRequestId, discussionId);
      } else {
        promise = this.resolveAll(mergeRequestId, discussionId);
      }

      promise.then(function (resp) {
        return resp.json();
      }).then(function (data) {
        discussion.loading = false;
        var resolvedBy = data ? data.resolved_by : null;

        if (isResolved) {
          discussion.unResolveAllNotes();
        } else {
          discussion.resolveAllNotes(resolvedBy);
        }

        if (gl.mrWidget) gl.mrWidget.checkStatus();
        discussion.updateHeadline(data);
      }).catch(function () {
        return new __WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */]('An error occurred when trying to resolve a discussion. Please try again.');
      });
    }
  }, {
    key: 'resolveAll',
    value: function resolveAll(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];

      discussion.loading = true;

      return this.discussionResource.save({
        mergeRequestId: mergeRequestId,
        discussionId: discussionId
      }, {});
    }
  }, {
    key: 'unResolveAll',
    value: function unResolveAll(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];

      discussion.loading = true;

      return this.discussionResource.delete({
        mergeRequestId: mergeRequestId,
        discussionId: discussionId
      }, {});
    }
  }]);

  return ResolveServiceClass;
}();

gl.DiffNotesResolveServiceClass = ResolveServiceClass;

/***/ }),

/***/ "./diff_notes/stores/comments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable object-shorthand, func-names, camelcase, no-restricted-syntax, guard-for-in, comma-dangle, max-len, no-param-reassign */
/* global DiscussionModel */



window.CommentsStore = {
  state: {},
  get: function get(discussionId, noteId) {
    return this.state[discussionId].getNote(noteId);
  },
  createDiscussion: function createDiscussion(discussionId, canResolve) {
    var discussion = this.state[discussionId];
    if (!this.state[discussionId]) {
      discussion = new DiscussionModel(discussionId);
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.state, discussionId, discussion);
    }

    if (canResolve !== undefined) {
      discussion.canResolve = canResolve;
    }

    return discussion;
  },
  create: function create(noteObj) {
    var discussion = this.createDiscussion(noteObj.discussionId);

    discussion.createNote(noteObj);
  },
  update: function update(discussionId, noteId, resolved, resolved_by) {
    var discussion = this.state[discussionId];
    var note = discussion.getNote(noteId);
    note.resolved = resolved;
    note.resolved_by = resolved_by;
  },
  delete: function _delete(discussionId, noteId) {
    var discussion = this.state[discussionId];
    discussion.deleteNote(noteId);

    if (discussion.notesCount() === 0) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].delete(this.state, discussionId);
    }
  },
  unresolvedDiscussionIds: function unresolvedDiscussionIds() {
    var ids = [];

    for (var discussionId in this.state) {
      var discussion = this.state[discussionId];

      if (!discussion.isResolved()) {
        ids.push(discussion.id);
      }
    }

    return ids;
  }
};

/***/ })

},["./diff_notes/diff_notes_bundle.js"]);


// WEBPACK FOOTER //
// diff_notes.136f49d0122157165cf3.bundle.js